import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <InlineAlert variant="important" slots="text" mdxType="InlineAlert" />
    <p>{`This mutation is automatically available on `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/en/docs/commerce/cloud-service/overview"
      }}>{`Adobe Commerce as a Cloud Service`}</a>{` (SaaS) projects. Adobe Commerce on-premises and Cloud infrastructure (PaaS) projects can `}<a parentName="p" {...{
        "href": "./index.md"
      }}>{`install separate modules`}</a>{` to provide this functionality.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      